document.addEventListener("DOMContentLoaded", function() {
    const blocksTable = document.querySelectorAll('.block-table > .content > .inner > .mobile');
    if (blocksTable) {
        blocksTable.forEach(block => {
            new Splide(block, {
                drag: false
            }).mount();

            let next = block.getElementsByClassName('splide__arrow--next')[0];
            let previous = block.getElementsByClassName('splide__arrow--prev')[0];
            let fakeNext = block.getElementsByClassName('simulate__arrow-right')[0];
            let fakePrevious = block.getElementsByClassName('simulate__arrow-left')[0];
            let pager = block.getElementsByClassName('numbers')[0];
            let pageNumber = parseInt(pager.getAttribute('data-number'));
            var currentPage = 1;

            handlerText(pager,currentPage, pageNumber)

            fakeNext.addEventListener("click", function() {
                next.click();
                if (currentPage < pageNumber) {
                    currentPage = currentPage + 1;
                }
                handlerText(pager, currentPage, pageNumber)
            });

            fakePrevious.addEventListener("click", function() {
                previous.click();
                if (currentPage > 1) {
                    currentPage = currentPage - 1;
                }
                handlerText(pager, currentPage, pageNumber)
            });
        });

        function handlerText(block, current, max) {
            block.innerHTML = (current + "/" + max).toString();
        }
    }
});